import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { LoginPage } from './pages/LoginPage';
import { InstructorDashboard } from './pages/InstructorDashboard';
import { StudentDashboard } from './pages/StudentDashboard';
import { NotFoundPage } from './pages/NotFoundPage';
import { AccessDeniedPage } from './pages/AccessDeniedPage';
import { ProtectedRoute } from './components/common/ProtectedRoute';
import { TestSolverPage } from './pages/TestSolverPage';
import { TestReviewPage } from './pages/TestReviewPage'; // <-- IMPORT
import './App.css';

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<LoginPage />} />

      {/* CHRONIONE TRASY */}
      <Route
        path="/instruktor"
        element={
          <ProtectedRoute allowedRoles={['instruktor']}>
            <InstructorDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/kursant"
        element={
          <ProtectedRoute allowedRoles={['kursant']}>
            <StudentDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/test/:testId"
        element={
          <ProtectedRoute allowedRoles={['kursant']}>
            <TestSolverPage />
          </ProtectedRoute>
        }
      />
      {/* NOWA TRASA */}
      <Route
        path="/przeglad/:attemptId" 
        element={
          <ProtectedRoute allowedRoles={['kursant']}>
            <TestReviewPage />
          </ProtectedRoute>
        }
      />
      
      {/* STRONY BŁĘDÓW */}
      <Route path="/brak-dostepu" element={<AccessDeniedPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;